
<template>
  <div class="areas">
        <div class="area-data">{{defaultValue | valueFromt}}</div>
        <!-- <img class="area-icon" src="../../../assets/app/addAddress.png" alt=""> -->
  </div>
</template>
<script>
export default {
  props: {
    // 是否展示 model
    showModel: {
      type: Boolean,
      default: false
    },
    // 值
    defaultValue: {
      type: [String],
      default: '全省'
    }
  },
  filters: {
    // 去掉数值前面的字母
    valueFromt: function(value) {
      if (!value) return "";
      if (value.includes("_")) {
        return value.slice(2);
      } else {
        return value;
      }
    }
  },
  data() {
    return {
    };
  },
};
</script>
<style lang="less" scoped>
.areas {
  position: relative;
  font-size: 0.28rem;
  color: #fff;
  min-height: 0.58rem;
  height: 100%;
  line-height: 0.58rem;
  text-align: center;
  border: 0.02rem solid #eee;
  border-radius: 0.06rem;
  .area-icon {
    position: absolute;
    right: 0.2rem;
    top: 0.04rem;
    width: 0.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/app/add/selectArea.vue